var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-field-container"},[_c('text-field',{attrs:{"autocomplete":_vm.autocomplete,"role":_vm.role,"value":_vm.searchTerm,"label":_vm.tSearch},on:{"input":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }